// AFN 品牌配置。只放品牌和环境差异, 业务逻辑不得写在这里。
export default {
  appId: 'afn',
  name: 'afn',
  publicName: 'AFN',
  servePath: '/api',
  theme: {
    primaryColor: '#44b4fd',
    primaryWarnColor: '#f7b500',
    primaryBorderRadius: '5px'
  },
  env: {
    dev: {
      remoteBaseUrl: 'https://cl-test.afnsmart.com/api/0/web/0',
      wssUrl: 'wss://cl-test.afnsmart.com/monitor/'
    },
    test: {
      remoteBaseUrl: 'https://cl-test.afnsmart.com/api/0/web/0',
      wssUrl: 'wss://cl-test.afnsmart.com/monitor/'
    },
    prod: {
      remoteBaseUrl: 'https://cl.afnsmart.com/api/0/web/0',
      wssUrl: 'wss://cl.afnsmart.com/monitor/'
    }
  }
}
